import dayjs from 'dayjs';
import moment from 'moment';
import { locale } from '../locale/locale-utils';
import Resources from './resources';
import UrlHelper from './url-helper';

export function handleDefaults(defaultObj, dynamicObj) {
    for (const key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

export function capitalise(word) {
    const firstLetter = word.charAt(0);
    const firstLetterCap = firstLetter.toUpperCase();
    const remainingLetters = word.slice(1);
    return firstLetterCap + remainingLetters;
}
export const formatDate = (utcString, DATE_FORMAT = 'DD MMMM YYYY') => {
    const localTime = utcString.replace(/Z$/, '');

    return dayjs(localTime).format(DATE_FORMAT);
};

export const formatDateForPayload = (utcString, DATE_FORMAT = 'MM-DD-YYYY') => dayjs(utcString).format(DATE_FORMAT);

export const isUndefined = value => value === undefined || value === null;

export function calculateTotal(data) {
    return data.map(item => item.total).reduce((acc, val) => acc + val, 0);
}

// Class-details needs to use totalCertificates, as its data is setup differently
export function calculateClassTotal(data) {
    const totalNew = data.map(item => item.totalNew).reduce((prev, curr) => prev + curr, 0);
    const totalPast = data.map(item => item.totalPast).reduce((prev, curr) => prev + curr, 0);
    return totalNew + totalPast;
}

export const CERTIFICATE_DOWNLOAD_LIMIT = 200;
export function exportStudentCertificates(classroomId, filterText, selectedDateRange) {
    // eslint-disable-next-line no-underscore-dangle
    const appConfig = window._env_;
    const authToken = Resources.env.authToken;
    const queryParams = [
        `authToken=${authToken}`,
        `classroomId=${classroomId}`,
        `nameFilter=${filterText || ''}`,
        `startDate=${formatDateForPayload(selectedDateRange.startDate)}`,
        `endDate=${formatDateForPayload(selectedDateRange.endDate)}`,
        `locale=${locale()}`
    ];
    let url = '';

    if (UrlHelper.isRunningOnDeveloperMachine()) {
        queryParams.push(`env=${Resources.env.name}`);
    } else {
        url = appConfig.SchoolUsageReportsGatewayBaseUrl;
    }

    url += `/school/export/classroom/usage?${queryParams.join('&')}`;

    window.open(url, '_blank');
}

/**
 * Appends all params in paramData to the URL as well as the current auth token
 */
export async function getDownloadUrl({ resourceUrl, paramData, dateFormat = 'DD-MM-YYYY' }) {
    const baseUrl = await Resources.env.substituteConfigurationItems(resourceUrl);
    const dateParams = ['startDate', 'endDate'];
    dateParams.forEach((dateParam) => {
        if (paramData[dateParam]) {
            paramData[dateParam] = formatParamDate(paramData[dateParam], dateFormat);
        }
    });
    const parameters = UrlHelper.generateQueryString({
        ...paramData
    });
    return `${baseUrl}?${parameters.join('&')}`;
}

/*
 * Formats date into format needed by certificate gateway
 */
function formatParamDate(date, dateFormat) {
    return moment(date).format(dateFormat);
}



// WEBPACK FOOTER //
// ./helpers/utils.js